
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoVeiculoMarcaModelo from '@/servicos/Cadastros/Veiculo/ServicoVeiculoMarcaModelo';
import VeiculoMarcaModeloModal from './VeiculoMarcaModeloModal.vue';

export default defineComponent({
  name: 'VeiculoMarcaModelo',
  components: {
    TelaPadraoCrud,
    VeiculoMarcaModeloModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud, preencherCamposOrdenacao,
    } = useCrudBase();

    const servicoVeiculoMarcaModelo = new ServicoVeiculoMarcaModelo();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do modelo do veículo:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 1, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Código Interno', dataIndex: 'codigoInterno', key: 'CodigoInterno', position: 2, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Código Denatran', dataIndex: 'codigoDenatran', key: 'CodigoDenatran', position: 3, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Marca', dataIndex: 'codigoMarca', key: 'CodigoMarca', position: 4, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Ano Fabricação', dataIndex: 'anoFabricacao', key: 'AnoFabricacao', position: 5, visible: true, ordering: true, align: 'left', width: 140,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 6, visible: true, align: 'left', width: 100, customRenderRow: ECustomRenderRow.TagAtiva,
      },
      {
        title: 'Ações', key: 'acoes', position: 7, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade = preencherCamposOrdenacao();

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoVeiculoMarcaModelo,
      refCrud,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
